'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = function Image(_ref) {
  var alt = _ref.alt,
      classNames = _ref.classNames,
      src = _ref.src;
  return _react2.default.createElement('img', { alt: alt, className: classNames.root, src: src });
};

Image.propTypes = {
  /**
   * The alt tag
   */
  alt: _propTypes2.default.string.isRequired,

  /**
   * The max height of the image (rhythm units)
   */
  maxHeight: _propTypes2.default.number,

  /**
   * The max width of the image (rhythm units)
   */
  maxWidth: _propTypes2.default.number,

  /**
   * The image src
   */
  src: _propTypes2.default.string.isRequired,

  /**
   * Custom styles to apply to the image
   */
  styles: _propTypes2.default.object
};

exports.default = (0, _withStyles2.default)(_styles2.default)(Image);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/image/index.js
// module id = 843
// module chunks = 0